import errorHandle from '../../../utils/errorHandle';
import { tripOrgDateFun, orgTripDetailsFun } from '../../../api/orgTripAPI';

export default async function fetchOrgTripData(setLoading, setPackData, setDates) {
    setLoading(true);
    const packId = window.location.pathname.split('/')[4];
    try {
        //search result filter olage price range band data is reseting
        //search result api on change min and max price should go
        // for getDateDetailsFun you get an array of objects with tripDate id, start and end date of each
        const allData = await Promise.all([await orgTripDetailsFun(packId), await tripOrgDateFun(packId, 'next')]);
        const sortedDates = allData[1].data.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
        setPackData(allData[0].data);
        setDates(sortedDates);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}

export async function fetchOrgTripDetails(setLoading, setPackData, tripId) {
    setLoading(true);
    try {
        //search result filter olage price range band data is reseting
        //search result api on change min and max price should go
        // for getDateDetailsFun you get an array of objects with tripDate id, start and end date of each
        const result = await orgTripDetailsFun(tripId);
        setPackData(result.data.unavailableDates);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}
